import type { RouteRecordRaw } from 'vue-router'
import LmsRoutes from '@/routes/Dashboard/lms'
import EmsRoutes from '@/routes/Dashboard/ems'
import SettingsRoutes from '@/routes/Dashboard/settings'

export default <RouteRecordRaw[]>[...LmsRoutes, ...EmsRoutes, ...SettingsRoutes]
